<template>
    <div>
        <b-loading :is-full-page="true" :active.sync="loading"></b-loading>

        <div class="columns is-centered">
            <div class="column is-full has-text-centered">
                <b-field label="Display en home">
                    <b-switch
                    v-model="basicInfo.displayCarousel"
                    @input="updateBaseInfo">
                    </b-switch>
                </b-field>
            </div>
        </div>

        <div class="columns is-multiline is-centered">
            <div v-for="x in slides" :key="x.id" class="column is-half has-text-centered">
                <p class="title is-size-5">
                    {{x.caption}}
                    <span>
                        <a class="has-text-danger"
                        @click="deleteSlide({isNew:false, index:x.id})">
                            <b-icon icon="trash" size="is-small"></b-icon>
                        </a>
                    </span>
                </p>
                <img :src="x.image" class="slide">
            </div>
        </div>

        <div class="columns">
            <div class="column has-text-centered is-full">
                <b-button
                type="is-primary"
                rounded
                @click="addModal=true">
                    <b-icon icon="save" size="is-small"></b-icon>
                    Agregar nuevas imagenes.
                </b-button>
            </div>
        </div>

        <b-modal :active.sync="addModal"  scroll="keep">
            <div class="modal-card" style="width: auto">
                <div class="modal-card-body">
                    <CarouselElement
                    v-for="(x, i) in newSlides"
                    :key="i"
                    :data="x"
                    :index="i"
                    :newSlide="true"
                    @deleteElement="deleteSlide"/>
                    <div class="columns is-multiline">
                        <div class="column is-full">
                            <b-button
                            type="is-light"
                            rounded
                            @click="pushNewSlide">
                                <b-icon icon="plus" size="is-small"></b-icon>
                                Agregar nueva linea
                            </b-button>
                        </div>

                        <b-button
                            type="is-primary"
                            rounded
                            :loading="saveLoading"
                            @click="createSlides">
                                <b-icon icon="save" size="is-small"></b-icon>
                                Guardar slides
                        </b-button>
                        
                    </div>     
                </div>
            </div>
        </b-modal >


    </div>
</template>

<script>
import CarouselElement from "./CarouselElement.vue";
import {getHandler, postHandler, deleteHandler, patchHandler} from "./../../../../services/http.js"

export default {
    components:{
        CarouselElement
    },
    props:{
        slideList:{
            type:String,
            default:""
        },
        slideDetail:{
            type:String,
            default:""
        },
        slideCreate:{
            type:String,
            default:""
        },
        details:{
            type:String,
            default:""
        }
    },
    data(){
        return{
            newSlides:[
                {
                    image:"",
                    caption:""
                },
            ],
            slides:[],
            addModal:false,
            saveLoading:false,
            basicInfo:{}
        }
    },
    methods:{
        async fetchSlides(){
            this.loading = true
            let resp = await getHandler(this.slideList, {error:false, succes:false})
            console.log(resp)
            this.slides = resp
            this.loading = false
        },

        async createSlides(){
            this.saveLoading = true
            let msg={
                resource:"notify"
            }
            let resp = await postHandler(this.slideCreate, this.newSlides, {error:msg, success:msg})
            this.saveLoading = false
            this.newSlides = [
                {
                    image:"",
                    caption:""
                }
            ]
            this.fetchSlides()
            this.addModal = false
        },

        async fetchBaseDetails(){
            let resp = await getHandler(this.details, {error:false, success:false})
            this.basicInfo = resp
        },

        async updateBaseInfo(){
            let msg={
                resource:"notify"
            }
            let resp = await patchHandler(this.details, this.basicInfo, {error:msg, success:msg})
            
            
        },
        
        async deleteSlide(payload){
            if (payload.isNew){
                this.newSlides.splice(payload.index, 1)
            } else{
                let msg = {
                    resource:"notify"
                }
                let url = this.slideDetail.replace('0000', payload.index)
                let resp = await deleteHandler(url, {error:msg, success:msg})
                this.fetchSlides()
            }

        },
        pushNewSlide(){
            this.newSlides.push({
                image:"",
                caption:""
            })
        }
    },
    created(){
        this.fetchSlides(),
        this.fetchBaseDetails()
    }
}
</script>
<style lang="scss" scoped>
.slide{
    max-height: 250px;
    border:1px solid #ddd;
    border-radius: 5px;
}
</style>
